import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from './HttpInterceptor.service';
@NgModule({
	imports: [],
	providers: [
		HttpInterceptorService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpInterceptorService,
			multi: true,
		},
	],
})
export class HttpInterceptorModule {}
